<template>
  <div class="sortable-list-thumb-wrap">
    <img
      v-if="trackError"
      v-show="false"
      aria-hidden="true"
      :src="src"
      @error="onLoadError"
    >
    <div
      class="sortable-list-thumb"
      :style="thumbStyle"
    />
  </div>
</template>

<script>
/**
 * 可排序列表缩略图：用 background-image 展示，避免微信 WebView 长按 <img> 弹出「保存图片」。
 * 微信侧无关闭该菜单的官方接口，只能规避 img 标签。
 */
export default {
  name: 'SortableListThumb',
  props: {
    src: {
      type: String,
      required: true,
    },
    fallbackSrc: {
      type: String,
      default: '/static/images/icon_loader_failed_braseas.png',
    },
    /** 是否用隐藏 img 检测加载失败（静态图标可设为 false） */
    trackError: {
      type: Boolean,
      default: true,
    },
    /** trackError 时写入 item._thumbError，便于 Vue2 响应式 */
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    displaySrc() {
      if (this.trackError && this.item && this.item._thumbError) {
        return this.fallbackSrc
      }
      return this.src || this.fallbackSrc
    },
    thumbStyle() {
      return {
        backgroundImage: `url("${this.displaySrc}")`,
      }
    },
  },
  methods: {
    onLoadError() {
      if (!this.trackError || !this.item || this.item._thumbError) return
      this.$set(this.item, '_thumbError', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.sortable-list-thumb-wrap {
  flex-shrink: 0;
}

.sortable-list-thumb {
  height: 60px;
  width: 60px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-touch-callout: none;
  user-select: none;
  pointer-events: none;
}
</style>
